import React from 'react';

interface State {
  id: string;
  code: string;
  description: string;
  discount_type: string;
  discount_value: number;
  min_purchase_amount: number;
  max_discount_amount: number;
  start_date: string;
  end_date: string;
  usage_limit: number;
  status: number;
  coupon_type: number;
  plan_id: number | string;
  editclicked: boolean;
}

interface SetState {
  (newState: State): void;
}

interface ContextValue {
  state: State;
  setState: SetState;
}

export const MyContext = React.createContext<ContextValue>({
  state: { 
    id: '', 
    code: '',
    description:'',
    discount_type: 'Percentage',
    discount_value: 0,
    min_purchase_amount: 0,
    max_discount_amount: 0,
    start_date: '',
    end_date: '',
    usage_limit: 0,
    status: 1,
    coupon_type: 1,
    plan_id: '',
    editclicked: false 
  },
  setState: () => {}
});